import React from 'react';

const Footer = () => {
    return (
        <div style={{ backgroundColor: '#007ad9', color: '#fff', display: "flex", width: "100%" }}>
          <p style={{flexGrow: 1, textAlign: "center"}}>© 2024 Marlin Aquatic Center Viewer Edition. All Rights Reserved.</p>
        </div>
    );
};

export default Footer;